<template>
  <div>
    <div class="auth-wrapper auth-v1">
      <div class="auth-inner">
        <v-card class="auth-card pa-4">
          <!-- logo -->
          <v-card-title class="d-flex align-center justify-center py-7">
            <div class="d-flex align-center mb-4">
              <v-img src="/images/piiri_p_2025.png" max-height="30px" max-width="30px" alt="logo" contain
                class="me-1"></v-img>

              <h2 class="text-2xl font-weight-semibold">
                {{ $t("Tervetuloa Piiriin") }}
              </h2>
            </div>
          </v-card-title>

          <!-- title -->
          <!-- <v-card-text>
          <p class="mb-2">
            Please sign-in to your account and start the adventure
          </p>
        </v-card-text> -->

          <v-form ref="initLoginForm" lazy-validation @submit.prevent="initLogin">
            <v-row>
              <v-col cols="12">
                <v-text-field v-model="usernamephone" :label="$t('Puhelinnumero')" :placeholder="$t('Puhelinnumero')"
                  outlined required class="mb-2" hide-details="auto" :rules="[required]"></v-text-field>
              </v-col>
              <v-col cols="12" v-if="!loginMethod">
                <v-btn block elevation="2" class="mb-3" x-large color="primary" type="submit">
                  {{ $t("Jatka") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-form>

          <template v-if="loginMethod == 1">
            <v-form ref="usernameloginForm" lazy-validation v-on:submit.prevent="login">
              <v-row>
                <v-col cols="12">
                  <v-text-field ref="passwordField" type="password" outlined v-model="password" :label="$t('Salasana')"
                    required class="mb-2" hide-details="auto" :rules="[required]" />
                </v-col>
                <v-col cols="12">
                  <v-btn block elevation="2" x-large color="primary" type="submit">
                    {{ $t("Kirjaudu sisään") }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-form>
          </template>

          <template v-else-if="loginMethod == 2">
            <v-form ref="pinloginForm" lazy-validation>
              <v-row>
                <v-col cols="12">
                  <v-alert color="info" text outlined class="mb-4">
                    <div class="mb-3">
                      {{ $t("Saat PIN-koodin tekstiviestillä mikäli puhelinnumerosi on järjestelmässämme. Syötä se
                      alle.") }}
                    </div>
                    <div>
                      {{ $t("Jos et saanut PIN-koodia, tarkista että syötit puhelinnumerosi oikein.") }}
                    </div>
                  </v-alert>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="text-center">
                  <v-otp-input ref="pinField" length="8" v-model="pin" :disabled="submittingPin"
                    @finish="onPinFinished">
                  </v-otp-input>
                  <v-overlay absolute :value="submittingPin">
                    <v-progress-circular indeterminate color="primary"></v-progress-circular>
                  </v-overlay>
                </v-col>
              </v-row>
            </v-form>
          </template>

          <template>
            <v-alert color="error" text v-if="error" class="mt-2">
              {{ error }}
            </v-alert>
          </template>


          <div class="text-center mt-4">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn text color="primary" dark v-bind="attrs" v-on="on">
                  <v-img :src="activeLocale.img" :alt="$i18n.locale" height="14px" width="22px" class="me-2"></v-img>
                  <span v-if="$vuetify.breakpoint.smAndUp">{{ activeLocale.title }}</span>
                </v-btn>
              </template>
              <v-list>
                <v-list-item-group :value="$i18n.locale" @change="updateActiveLocale">
                  <v-list-item v-for="locale in locales" :key="locale.locale" :value="locale.locale">
                    <v-list-item-icon v-if="locale.locale === $i18n.locale" class="me-2">
                      <v-icon>{{ icons.mdiCheck }}</v-icon>
                    </v-list-item-icon>
                    <v-img :src="locale.img" height="14px" width="22px" :alt="locale.locale" class="me-2"
                      contain></v-img>
                    <v-list-item-title>{{ locale.title }}</v-list-item-title>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </v-menu>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import AppBarI18n from "@core/layouts/components/app-bar/AppBarI18n.vue";
import { i18n, loadLanguageAsync } from "@/plugins/i18n";
import useAppConfig from "@core/@app-config/useAppConfig";
import { computed } from "@vue/composition-api";
import { supportedLocales } from "@/@core/utils/i18n_utils";

// eslint-disable-next-line object-curly-newline
import {
  mdiEyeOutline,
  mdiEyeOffOutline,
  mdiCheck,
} from "@mdi/js";
import { nextTick, ref } from "@vue/composition-api";
import themeConfig from "@themeConfig";
import useAuth from "@/useAuth";
import { required } from "@core/utils/validation";
import api from "@/api";
import router from "@/router";


export default {
  components: {
    AppBarI18n,
  },
  setup() {
    const { setToken, setUser, setTenant, logoutUser, persistTenants } = useAuth();

    const isPasswordVisible = ref(false);
    const mobileAttemptId = ref("");
    const usernamephone = ref("");
    const phonenumber = ref("");
    const loginMethod = ref(0);
    const password = ref("");
    const username = ref("");
    const email = ref("");
    const error = ref("");
    const pin = ref("");
    const submittingPin = ref(false);

    // Element refs
    const initLoginForm = ref(null);
    const passwordField = ref(null);
    const pinField = ref(null);

    const { isRtl } = useAppConfig();

    const locales = supportedLocales;

    const activeLocale = computed(() => {
      let locale = locales.find((a) => a.locale == i18n.locale);
      return locale ?? locales[0];
    });

    const updateActiveLocale = async (locale) => {
      // Set to RTL mode if locale is arabic
      isRtl.value = locale === "ar";

      await loadLanguageAsync(locale);

      setTimeout(() => {
        window.location.href = window.location.href;
      }, 200);
    };


    const initLogin = async () => {
      error.value = "";

      if (initLoginForm.value.validate()) {
        const response = await api.initLogin(usernamephone.value);

        if (response.ok) {
          if (response.data.login_method == 1) {
            username.value = usernamephone.value;
            loginMethod.value = response.data.login_method;

            nextTick(() => {
              passwordField.value.focus();
            });
          } else {
            phonenumber.value = usernamephone.value;
            submitPhone();
          }
        } else {
          error.value = i18n.t("Kirjautuminen epäonnistui");
        }
      }
    };

    const login = async () => {
      error.value = "";
      const response = await api.usernameLogin(username.value, password.value);

      if (response.ok) {
        initSession(response.data.token, response.data.expiry);
      } else {
        error.value = i18n.t("Kirjautuminen epäonnistui");
      }
    };

    const submitPhone = async () => {
      const response = await api.submitPhone(phonenumber.value);
      if (response.ok) {
        loginMethod.value = 2;
        mobileAttemptId.value = response.data.attempt_id;

        nextTick(() => {
          pinField.value.focus();
        });
      } else {
        error.value = response.error;
      }
    };

    const submitPinCode = async () => {
      submittingPin.value = true;
      error.value = "";
      const response = await api.submitPin(
        phonenumber.value,
        pin.value,
        mobileAttemptId.value
      );

      submittingPin.value = false;
      if (response.ok) {
        if (response.data.length > 1) {
          persistTenants(response.data);
        }
        initSession(response.data[0].token, response.data[0].expiry);
      } else {
        pin.value = "";
        error.value = i18n.t("Kirjautuminen epäonnistui, tarkista pin koodi");
        pinField.value.focus();
      }
    };

    const onPinFinished = async () => {
      submitPinCode();
    };

    const initSession = async (token, token_expiry) => {
      setToken(token, token_expiry);

      const userResponse = await api.getUserProfile();
      if (userResponse.ok) {
        setUser(userResponse.data);
      } else {
        logoutUser();
        return;
      }

      const tenantResponse = await api.getTenant();
      if (tenantResponse.ok) {
        setTenant(tenantResponse.data);
      } else {
        logoutUser();
        return;
      }

      router.replace("/home");
    };

    return {
      isPasswordVisible,
      email,
      password,
      usernamephone,
      loginMethod,
      initLogin,
      login,
      submitPinCode,
      onPinFinished,
      initLoginForm,
      passwordField,
      pinField,
      pin,
      error,
      locales,
      updateActiveLocale,
      activeLocale,
      icons: {
        mdiEyeOutline,
        mdiEyeOffOutline,
        mdiCheck,
      },
      required,
      appName: themeConfig.app.name,
      appLogo: themeConfig.app.logo,
      submittingPin,
    };
  },
};
</script>

<style lang="scss">
@import "@core/preset/preset/pages/auth.scss";
</style>
